<div class="wrapper-container">
    <div class="header">
        <h4>Plans</h4>
        <app-button theme="primary" size="xsmall" (click)="createPlan()">Create Plan</app-button>
    </div>
    <app-loader class="loader" *ngIf="loaderView"></app-loader>
    <div class="plans-container">
    <ng-container *ngIf="!loaderView">
        <div class="no-content-container" *ngIf="!plans?.length">
        <img src="assets/24x24/Subscription-plan.svg" alt="">
        <h4>Subscription plan not created yet!</h4>
        <p>Once you create a plan it will appear here.</p>
    </div>
    <ng-container *ngFor="let plan of plans">
        <app-cards [plan]="plan" (editPlan)="editPlan($event)"></app-cards>
    </ng-container>
    </ng-container>
    </div>
</div>